import { defineStore, storeToRefs } from "pinia";
import { computed, ref } from "vue";
import useMyFetch from "@stores/useMyFetch";
import { useSurveyStore } from "@stores/survey/survey";
import { useSurveyLocalesStore } from "@stores/survey/surveyLocales";

export const useQuestionListStore = defineStore("questionList", () => {
  const surveyStore = useSurveyStore();
  const { token } = storeToRefs(surveyStore);

  const surveyQuestions = ref([]);
  const cardList = ref([]);

  // FIXME: this is function has to be in its own store surveyQuestionsStore
  const fetchQuestions = async () => {
    const surveyToken = token.value;
    const { response, data } = await useMyFetch(`/surveys/${surveyToken}/questions`).get().json();
    if (response.value.ok) {
      surveyQuestions.value = data.value;
    }
  };

  // FIXME: this is function has to be in its own store reportCardListStore
  const fetchCardList = async () => {
    const { response, data } = await useMyFetch(`/surveys/${token.value}/report_cards`).get().json();
    if (response.value.ok) cardList.value = data.value;
  };

  const crosstabQuestionOptions = computed(() => {
    // Only single-choice types allowed for crosstabs to ensure mutually exclusive groups
    const allowedTypes = ["single", "rating", "slider", "nps"];
    return surveyQuestions.value
      .filter((q) => !q.is_admin_only && allowedTypes.includes(q.question_type))
      .map((q) => ({ label: formatCardLabel(q), value: q.id }));
  });

  const cardOptions = computed(() => {
    return cardList.value.map((c) => ({ label: formatCardLabel(c, true), value: c.card_token }));
  });

  // Cards that can be used as chart data sources
  const chartableCards = computed(() => {
    const allowedTypes = ["single", "multiple", "ranking", "rating", "slider", "image_choice", "matrix", "nps", "open", "open_multiple"];
    return cardList.value.filter((c) => allowedTypes.includes(c.question_type));
  });

  const formatCardLabel = (card, withType = false) => {
    const locale = useSurveyLocalesStore().currentLocale?.token;
    const title = card.localized_title?.[locale] || card.title;
    const name = card.name;
    const prefix = withType ? `${name} (${card.question_type})` : name;
    return title ? `${prefix} - ${title.replace("$$$", "...")}` : prefix;
  };

  return {
    surveyQuestions,
    cardList,

    fetchQuestions,
    fetchCardList,

    crosstabQuestionOptions,
    cardOptions,
    chartableCards,
  };
});
